// eslint-disable-next-line no-unused-vars
import { ILanguage } from './ILanguage';

export default {
  or: 'Or',
  text: 'click here to create an account',
  title: 'create an account',
} as ILanguage;
